import { passCodes } from '../passCodes';

export const step22talk = {
    id: 22,
    title: 'Most',
    taskText: `
        <p>
            Tajemství už známe, ale nevíme kam dál. Dřevorubec to ví, ale řekne nám to pouze pokud mu povíme, z kolika prken se skládá jedna lavička.
            Lavička je za lávkou, po cestě dál na ni narazíme. Jakmile to bude vědět, zbaví se svého trestu za krádež dřeva a bude moci z 
            tohoto místa odejít. A proč si to nezjistí sám? Protože prý neumí počítat.
        </p>
    `,
    cipher: {
        text: `
             Z kolika prken se skládá tato lavička?
        `,
        label: 'Úkol',
    },
    codeInputText: ' ',
    codeInputPassCodeRegexp: passCodes[8],
    additionalInfo: 'Odpovědí je jedno číslo',
    points: true,
    hints: [
        {
            text: 'Prken je 14',
        },
    ],
};
